import React from "react"
import { auditShape } from "utils/propTypeShapes"

const AttachmentRemovedAuditItemDetails = ({ audit }) => {
  const { attachmentName } = audit

  return (
    <div>
      Removed { attachmentName ? ` the attachment ${attachmentName}` : " an attachment"}.
    </div>
  )
}

AttachmentRemovedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default AttachmentRemovedAuditItemDetails
